import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
import VueYouTubeEmbed from 'vue-youtube-embed';
// v-viewer
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer';
import '@/assets/styles/fincas.css';
import clickOutside from '@/directives/click-ouside';
import i18n from './i18n';
Vue.config.productionTip = false;
Vue.use(VueYouTubeEmbed);
Vue.use(Viewer);
Vue.directive('click-outside', clickOutside);
new Vue({
    router,
    vuetify,
    i18n,
    render: h => h(App)
}).$mount('#app');
const output = {
    components: Vue.options.components,
    directives: {}
};
